import { configureStore } from "@reduxjs/toolkit";
import appReducer from "slices/appSlice";
import healthPlanReducer from "slices/hpSlice";
export default configureStore({
  reducer: {
    app: appReducer,
    healthPlan: healthPlanReducer,
  },
});
